import 'polyfills';
import Logger from 'logger';

import './applications';

Logger.info(`${process.env.REACT_APP_NAME} application started to load...`);
